import { styled } from '@mui/material/styles';

import muiPropForwarding from 'reservations/brand/helpers/muiPropForwarding';

type StaticMapComponentProps = {
  name: string;
  staticUrls: {
    static_url_desktop: string;
    static_url_tablet: string;
    static_url_mobile: string;
  };
  isMediumAndUp: boolean;
  isSmallAndUp: boolean;
};

const Image = styled('img', {
  shouldForwardProp: muiPropForwarding('width', 'height')
})(({ width, height }) => ({
  width,
  height
}));

const GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_WIDTH = '146px';
const GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_HEIGHT = '136px';
const GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_WIDTH = '100%';
const GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_HEIGHT = 'auto';

function StaticMapComponent({
  name,
  staticUrls,
  isMediumAndUp,
  isSmallAndUp
}: StaticMapComponentProps) {
  const responsiveWidth = isMediumAndUp
    ? GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_WIDTH
    : GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_WIDTH;

  const responsiveHeight = isMediumAndUp
    ? GOOGLE_MAPS_STATIC_IMAGE_DESKTOP_HEIGHT
    : GOOGLE_MAPS_STATIC_IMAGE_MOBILE_AND_TABLET_HEIGHT;

  let url;

  if (isMediumAndUp) {
    url = staticUrls.static_url_desktop;
  } else if (isSmallAndUp) {
    url = staticUrls.static_url_tablet;
  } else {
    url = staticUrls.static_url_mobile;
  }

  return (
    <Image
      data-testid="location-card-static-map"
      src={url}
      width={responsiveWidth}
      height={responsiveHeight}
      alt={name}
    />
  );
}

export default StaticMapComponent;
